export const vouchersTranslations = {
  ar: {
    title: 'سندات القبض والصرف',
    addNew: 'سند جديد',
    receipt: 'قبض',
    payment: 'صرف',
    voucherNumber: 'رقم السند',
    date: 'التاريخ',
    branch: 'الفرع',
    fromAccount: 'من حساب',
    toAccount: 'إلى حساب',
    contact: 'جهة الاتصال',
    amount: 'المبلغ',
    discount: 'الخصم',
    netAmount: 'صافي المبلغ',
    description: 'الوصف',
    status: 'الحالة',
    draft: 'مسودة',
    posted: 'مرحّل',
    cancelled: 'ملغي',
    actions: 'الإجراءات',
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    post: 'ترحيل',
    cancel: 'إلغاء',
    print: 'طباعة',
    filter: 'فلترة',
    refresh: 'تحديث',
    loading: 'جاري تحميل السندات...',
    noVouchers: 'لا توجد سندات',
    deleteSuccess: 'تم حذف السند بنجاح',
    deleteError: 'فشل حذف السند',
    postSuccess: 'تم ترحيل السند بنجاح',
    postError: 'فشل ترحيل السند',
    cancelSuccess: 'تم إلغاء السند بنجاح',
    cancelError: 'فشل إلغاء السند',
    cancelReason: 'سبب الإلغاء:',
    saveSuccess: 'تم حفظ السند بنجاح',
    saveError: 'فشل حفظ السند',
    voucherType: 'نوع السند',
    receiptVoucher: 'سند قبض',
    paymentVoucher: 'سند صرف',
    receiveMoney: 'تحصيل مبلغ',
    payMoney: 'صرف مبلغ',
    autoGenerated: 'رقم تلقائي',
    selectBranch: 'اختر الفرع',
    accounts: 'الحسابات',
    selectAccount: 'اختر الحساب',
    selectContact: 'اختر جهة الاتصال',
    amounts: 'المبالغ',
    advancedOptions: 'خيارات متقدمة',
    paymentMethod: 'طريقة الدفع',
    selectPaymentMethod: 'اختر طريقة الدفع',
    checkTransferNo: 'رقم الشيك/الحوالة',
    dueDate: 'تاريخ الاستحقاق',
    bankName: 'اسم البنك',
    currency: 'العملة',
    defaultCurrency: 'العملة الافتراضية',
    costCenter: 'مركز التكلفة',
    selectCostCenter: 'اختر مركز التكلفة',
    foreignAmount: 'المبلغ بالعملة الأجنبية',
    exchangeRate: 'سعر الصرف',
    notes: 'ملاحظات',
    enterNotes: 'أدخل ملاحظات إضافية...',
    cannotEditPosted: 'هذا السند مرحّل ولا يمكن تعديله',
    cannotEditCancelled: 'هذا السند ملغي',
    printVoucher: 'طباعة السند',
    receiver: 'المستلم',
    accountant: 'المحاسب',
    manager: 'المدير',
    totalReceipts: 'إجمالي القبض',
    totalPayments: 'إجمالي الصرف',
    manageVouchers: 'إدارة سندات القبض والصرف',
    net: 'الصافي',
    allBranches: 'جميع الفروع',
    all: 'الكل',
    type: 'النوع',
    noVouchersToDisplay: 'لا توجد سندات للعرض',
    voucherNo: 'رقم السند',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    searchPlaceholder: 'بحث برقم السند أو الجهة أو الحساب أو الوصف...',
    todayOnlyHint: 'يعرض سندات اليوم. غيّر التاريخ أو ابحث لعرض فترات أخرى.',
    viewReceiptVoucher: 'عرض سند قبض',
    viewPaymentVoucher: 'عرض سند صرف',
    editReceiptVoucher: 'تعديل سند قبض',
    editPaymentVoucher: 'تعديل سند صرف',
    newReceiptVoucher: 'سند قبض جديد',
    newPaymentVoucher: 'سند صرف جديد',
    fromAccountCustomerSource: 'من حساب (العميل/المصدر)',
    fromAccountCashBank: 'من حساب (الخزينة/البنك)',
    toAccountCashBank: 'إلى حساب (الخزينة/البنك)',
    toAccountExpenseVendor: 'إلى حساب (المصروف/المورد)',
    customerOptional: 'العميل (اختياري)',
    vendorOptional: 'المورد (اختياري)',
    postOnSave: 'ترحيل السند فور الحفظ',
    postOnSaveHint: 'عند التفعيل يُنشأ القيد المحاسبي مباشرة. عند الإلغاء يُحفظ السند كمسودة ويمكن ترحيله لاحقاً.',
    saveAndPostSuccess: 'تم حفظ السند وترحيله بنجاح',
    settleReceiptWithInvoicesPosted: 'تم إنشاء سند القبض وترحيله وتسديد الفواتير المختارة',
    settleReceiptWithInvoicesDraft: 'تم إنشاء سند القبض وتسديد الفواتير المختارة',
  },
  en: {
    title: 'Vouchers',
    addNew: 'New Voucher',
    receipt: 'Receipt',
    payment: 'Payment',
    voucherNumber: 'Voucher Number',
    date: 'Date',
    branch: 'Branch',
    fromAccount: 'From Account',
    toAccount: 'To Account',
    contact: 'Contact',
    amount: 'Amount',
    discount: 'Discount',
    netAmount: 'Net Amount',
    description: 'Description',
    status: 'Status',
    draft: 'Draft',
    posted: 'Posted',
    cancelled: 'Cancelled',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    post: 'Post',
    cancel: 'Cancel',
    print: 'Print',
    filter: 'Filter',
    refresh: 'Refresh',
    loading: 'Loading vouchers...',
    noVouchers: 'No vouchers',
    deleteSuccess: 'Voucher deleted successfully',
    deleteError: 'Failed to delete voucher',
    postSuccess: 'Voucher posted successfully',
    postError: 'Failed to post voucher',
    cancelSuccess: 'Voucher cancelled successfully',
    cancelError: 'Failed to cancel voucher',
    cancelReason: 'Cancel reason:',
    saveSuccess: 'Voucher saved successfully',
    saveError: 'Failed to save voucher',
    voucherType: 'Voucher Type',
    receiptVoucher: 'Receipt',
    paymentVoucher: 'Payment',
    receiveMoney: 'Receive money',
    payMoney: 'Pay money',
    autoGenerated: 'Auto-generated',
    selectBranch: 'Select Branch',
    accounts: 'Accounts',
    selectAccount: 'Select Account',
    selectContact: 'Select Contact',
    amounts: 'Amounts',
    advancedOptions: 'Advanced Options',
    paymentMethod: 'Payment Method',
    selectPaymentMethod: 'Select Payment Method',
    checkTransferNo: 'Check/Transfer No.',
    dueDate: 'Due Date',
    bankName: 'Bank Name',
    currency: 'Currency',
    defaultCurrency: 'Default Currency',
    costCenter: 'Cost Center',
    selectCostCenter: 'Select Cost Center',
    foreignAmount: 'Foreign Amount',
    exchangeRate: 'Exchange Rate',
    notes: 'Notes',
    enterNotes: 'Enter additional notes...',
    cannotEditPosted: 'This voucher is posted and cannot be edited',
    cannotEditCancelled: 'This voucher is cancelled',
    printVoucher: 'Print Voucher',
    receiver: 'Receiver',
    accountant: 'Accountant',
    manager: 'Manager',
    totalReceipts: 'Total Receipts',
    totalPayments: 'Total Payments',
    manageVouchers: 'Manage receipt and payment vouchers',
    net: 'Net',
    allBranches: 'All Branches',
    all: 'All',
    type: 'Type',
    noVouchersToDisplay: 'No vouchers to display',
    voucherNo: 'Voucher No.',
    fromDate: 'From Date',
    toDate: 'To Date',
    searchPlaceholder: 'Search by voucher number, contact, account, or description...',
    todayOnlyHint: 'Showing today\'s vouchers. Change the date or search for other periods.',
    viewReceiptVoucher: 'View Receipt Voucher',
    viewPaymentVoucher: 'View Payment Voucher',
    editReceiptVoucher: 'Edit Receipt Voucher',
    editPaymentVoucher: 'Edit Payment Voucher',
    newReceiptVoucher: 'New Receipt Voucher',
    newPaymentVoucher: 'New Payment Voucher',
    fromAccountCustomerSource: 'From Account (Customer/Source)',
    fromAccountCashBank: 'From Account (Cash/Bank)',
    toAccountCashBank: 'To Account (Cash/Bank)',
    toAccountExpenseVendor: 'To Account (Expense/Vendor)',
    customerOptional: 'Customer (Optional)',
    vendorOptional: 'Vendor (Optional)',
    postOnSave: 'Post voucher on save',
    postOnSaveHint: 'When checked, the journal entry is created immediately. When unchecked, the voucher is saved as a draft for later posting.',
    saveAndPostSuccess: 'Voucher saved and posted successfully',
    settleReceiptWithInvoicesPosted: 'Receipt voucher posted and selected invoices settled',
    settleReceiptWithInvoicesDraft: 'Receipt voucher created and selected invoices settled',
  },
  fr: {
    title: 'Pièces justificatives',
    addNew: 'Nouvelle pièce',
    receipt: 'Reçu',
    payment: 'Paiement',
    voucherNumber: 'Numéro de pièce',
    date: 'Date',
    branch: 'Succursale',
    fromAccount: 'Du compte',
    toAccount: 'Au compte',
    contact: 'Contact',
    amount: 'Montant',
    discount: 'Remise',
    netAmount: 'Montant net',
    description: 'Description',
    status: 'Statut',
    draft: 'Brouillon',
    posted: 'Comptabilisé',
    cancelled: 'Annulé',
    actions: 'Actions',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    post: 'Comptabiliser',
    cancel: 'Annuler',
    print: 'Imprimer',
    filter: 'Filtrer',
    refresh: 'Actualiser',
    loading: 'Chargement des pièces...',
    noVouchers: 'Aucune pièce',
    deleteSuccess: 'Pièce supprimée avec succès',
    deleteError: 'Échec de la suppression de la pièce',
    postSuccess: 'Pièce comptabilisée avec succès',
    postError: 'Échec de la comptabilisation de la pièce',
    cancelSuccess: 'Pièce annulée avec succès',
    cancelError: 'Échec de l\'annulation de la pièce',
    cancelReason: 'Raison de l\'annulation:',
    saveSuccess: 'Pièce enregistrée avec succès',
    saveError: 'Échec de l\'enregistrement de la pièce',
    voucherType: 'Type de pièce',
    receiptVoucher: 'Reçu',
    paymentVoucher: 'Paiement',
    receiveMoney: 'Recevoir de l\'argent',
    payMoney: 'Payer de l\'argent',
    autoGenerated: 'Généré automatiquement',
    selectBranch: 'Sélectionner la succursale',
    accounts: 'Comptes',
    selectAccount: 'Sélectionner le compte',
    selectContact: 'Sélectionner le contact',
    amounts: 'Montants',
    advancedOptions: 'Options avancées',
    paymentMethod: 'Méthode de paiement',
    selectPaymentMethod: 'Sélectionner la méthode de paiement',
    checkTransferNo: 'N° de chèque/virement',
    dueDate: 'Date d\'échéance',
    bankName: 'Nom de la banque',
    currency: 'Devise',
    defaultCurrency: 'Devise par défaut',
    costCenter: 'Centre de coût',
    selectCostCenter: 'Sélectionner le centre de coût',
    foreignAmount: 'Montant en devise étrangère',
    exchangeRate: 'Taux de change',
    notes: 'Notes',
    enterNotes: 'Entrer des notes supplémentaires...',
    cannotEditPosted: 'Cette pièce est comptabilisée et ne peut pas être modifiée',
    cannotEditCancelled: 'Cette pièce est annulée',
    printVoucher: 'Imprimer la pièce',
    receiver: 'Destinataire',
    accountant: 'Comptable',
    manager: 'Gestionnaire',
    totalReceipts: 'Total des reçus',
    totalPayments: 'Total des paiements',
    manageVouchers: 'Gérer les pièces de recettes et de paiement',
    net: 'Net',
    allBranches: 'Toutes les succursales',
    all: 'Tout',
    type: 'Type',
    noVouchersToDisplay: 'Aucune pièce à afficher',
    voucherNo: 'N° de pièce',
    fromDate: 'Date de début',
    toDate: 'Date de fin',
    searchPlaceholder: 'Rechercher par n° de pièce, contact, compte ou description...',
    todayOnlyHint: 'Affiche les pièces d\'aujourd\'hui. Modifiez la date ou recherchez une autre période.',
    viewReceiptVoucher: 'Voir le reçu',
    viewPaymentVoucher: 'Voir le paiement',
    editReceiptVoucher: 'Modifier le reçu',
    editPaymentVoucher: 'Modifier le paiement',
    newReceiptVoucher: 'Nouveau reçu',
    newPaymentVoucher: 'Nouveau paiement',
    fromAccountCustomerSource: 'Du compte (Client/Source)',
    fromAccountCashBank: 'Du compte (Trésorerie/Banque)',
    toAccountCashBank: 'Au compte (Trésorerie/Banque)',
    toAccountExpenseVendor: 'Au compte (Dépense/Fournisseur)',
    customerOptional: 'Client (Optionnel)',
    vendorOptional: 'Fournisseur (Optionnel)',
    postOnSave: 'Comptabiliser la pièce à l\'enregistrement',
    postOnSaveHint: 'Si coché, l\'écriture comptable est créée tout de suite. Sinon la pièce reste en brouillon pour comptabilisation ultérieure.',
    saveAndPostSuccess: 'Pièce enregistrée et comptabilisée avec succès',
    settleReceiptWithInvoicesPosted: 'Reçu comptabilisé et factures sélectionnées réglées',
    settleReceiptWithInvoicesDraft: 'Reçu créé et factures sélectionnées réglées',
  },
}

